export Carousel from './components/Carousel';
export * as actions from './actions';
export reducer from './reducer'



/** WEBPACK FOOTER **
 ** ./src/app/modules/carousel/index.js
 **/